import { render, staticRenderFns } from "./xhs-audit-dialog.vue?vue&type=template&id=0201f705&scoped=true"
import script from "./xhs-audit-dialog.vue?vue&type=script&lang=js"
export * from "./xhs-audit-dialog.vue?vue&type=script&lang=js"
import style0 from "./xhs-audit-dialog.vue?vue&type=style&index=0&id=0201f705&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0201f705",
  null
  
)

export default component.exports